import gql from 'graphql-tag';

export default gql`
  fragment contactNgReasonFragment on ContactNgReason {
    id
    projectId
    reason
  }
`;
